import { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import {
  fetchAiTemplates,
  resetAiTemplatesList,
  templateGetAdded,
} from '../_actions/aiDocumentActions';
import { useTranslation } from 'react-i18next';
import { Select } from 'chakra-react-select';
import { AI_ENDPOINT } from '../_actions/endpoints';
import {
  withAsyncPaginate
} from "react-select-async-paginate";
import { isEmpty } from "lodash";
const CustomAsyncPaginate = withAsyncPaginate(Select);

export const customStyles = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided) => ({
    ...provided,
    width: '100%',
    cursor: 'pointer',
    color: 'gray.100',
    background: 'brand.dark',
    border: '1px solid',
    borderColor: 'gray.1000',
    borderRadius: '8px',
    _focus: {
      borderColor: 'gray.1000',
      background: 'brand.darker',
      color: 'brand.white',
    },
    _hover: {
      borderColor: 'gray.1000',
      background: 'brand.darker',
      color: 'brand.white',
      cursor: 'text',
    },
    _invalid: {
      borderColor: 'brand.negative',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'gray.300',
  }),
  valueContainer: (provided) => ({
    ...provided,
    paddingX: 2,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    bg: null,
    color: 'gray.100',
    paddingX: 2,
    fontSize: 'xl',
    borderColor: 'transparent',
    '> svg': {
      width: '1em',
      height: '1em',
    },
    height: '24px',
    borderRadius: '4px',
    marginLeft: '5px',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  menuList: (provided) => ({
    ...provided,
    background: 'brand.grey-darker',
    color: "brand.white",
    maxHeight: '400px',
    '::-webkit-scrollbar': {
      ...provided['::-webkit-scrollbar'],
      display: 'none',
    },
  }),
  menu: (provided) => ({
    ...provided,
    background: "brand.grey-darker",
    color: "brand.white",
    minWidth: '100%',
    width: 'initial',
    boxShadow: 'dark-lg',
  }),
  option: (provided, state) => {
    return {
      ...provided,
      fontSize: "16px",
      backgroundColor: 'transparent',
      color: state.selectProps.value.value === state.data.value.id
          ? 'primary.400'
          : state.isDisabled
          ? 'gray.300'
          : 'gray.100',
      _hover: {
        color: state.selectProps.value.value === state.data.value.id
          ? 'primary.400'
          : state.isDisabled
          ? 'gray.300'
          : 'brand.white',
        backgroundColor: state.isDisabled ? 'transparent' : 'gray.1200',
      },
    };
  },
  groupHeading: (provided, state) => ({
    ...provided,
    background: 'transparent',
    height: '0',
    padding: '0',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "brand.white",
    display: state.selectProps.menuIsOpen ? "none" : "block",
  }),
  input: (provided, state) => ({
    ...provided,
    color: "brand.white",
    background: "transparent",
    minWidth: "5px"
  }),
};

export const customStylesForResultsView = {
  ...customStyles,
  control: (provided, state) => ({
    ...provided,
    height: '40px',
    width: '100%',
    cursor: 'pointer',
    color: 'gray.100',
    background: 'brand.dark',
    border: '1px solid',
    borderColor: 'gray.1000',
    borderRadius: '8px',
    _focus: {
      borderColor: 'gray.1000',
      background: 'brand.darker',
      color: 'brand.white',
    },
    _hover: {
      borderColor: 'gray.1000',
      background: 'brand.darker',
      color: 'brand.white',
      cursor: 'text',
    },
  }),
};

const AiTemplatesSelect = (props) => {
  const { t } = useTranslation('ai', 'common');
  let signalToken = axios.CancelToken.source();
  const [loading, isLoading] = useState(true);
  const { data, templateList, loadMore } = props.document;

  useEffect(() => {
    fetchAiTemplates();
    return () => {
      signalToken.cancel('The user aborted a request.');
      props.resetDocument();
    };
  }, []);

  function fetchAiTemplates(key = '') {
    props.fetchAiTemplates(props, key, signalToken, 1, '', isLoading, true);
  }

  const documentTemplateData = {
    label: data?.prompt?.title,
    value: data?.prompt?.id,
  };

  let newOption = templateList.map((e) => {
    return {
      label: e.title,
      value: e,
    };
  });

 const loadOptions = (search, loadedOptions, { page }) =>{

  if(!isEmpty(templateList) && page === 1 && !search) {
    return {
      options: newOption,
      hasMore: loadMore,
      additional: {
        page: page + 1,
      },
    }
  }

   const  AI_NEW_ENDPOINT = search
   ? `${AI_ENDPOINT}?search=${search}`
   : `${AI_ENDPOINT}?page=${page}`;

  return axios.get(AI_NEW_ENDPOINT).then(res => {
    const options = res?.data?.results.map((e) => {
      return {
        label: e.title,
        value: e,
      };
    }) || [];
    return {
      options: options,
      hasMore: res?.data?.next,
      additional: {
        page: page + 1,
      },
    };
   }).catch(err => {
    console.error(err);
    return {
      options: [],
      hasMore: false,
    };
   })
  }

  return (
    <CustomAsyncPaginate
          SelectComponent={Select}
          chakraStyles={
            props.resultsView ? customStylesForResultsView : customStyles
          }
          onChange={props.onSelect}
          loadOptions={loadOptions}
          defaultOptions={newOption}
          value={{ value: documentTemplateData.value , label: documentTemplateData.label }}
          isSearchable
          additional={{
            page: 1,
          }}
          debounceTimeout={500}
        />
  );
};

const mapStateToProps = (state) => {
  return {
    document: state.document,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchAiTemplates: (
    props,
    key,
    signal,
    page,
    searchTerm,
    isLoading,
    isSelect
  ) =>
    dispatch(
      fetchAiTemplates(
        props,
        key,
        signal,
        page,
        searchTerm,
        isLoading,
        isSelect
      )
    ),
  templateGetAdded: (data) => dispatch(templateGetAdded(data)),
  resetDocument: () => dispatch(resetAiTemplatesList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AiTemplatesSelect);
